<template>
  <div class="layout">
    <div class="return-nav">
      <div class="return-nav-ope" @click.stop="goBack">
        <i class="yjh-icon icon-return"></i
        ><span class="return-text">{{title || '返回'}}</span
        ><span class="return-num" v-if="num !== ''">({{num}})</span>
      </div>
    </div>
    <div class="cont-return" ref="returnBody">
      <div class="card-container" :class="cardType">
       <router-view @back="goBack"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'return-layout',
  computed: {
    ...mapState({
      title: state => state.app.returnTitle,
      url: state => state.app.returnUrl,
      fullUrl: state => state.app.returnFullUrl,
      num: state => state.app.returnNum,
      params: state => state.app.params,
      cardType: state => state.app.cardType
    })
  },
  methods: {
    goBack() {
      // 标准库 主数据的新增和编辑 返回是关闭窗口
      if (['addData', 'editData'].includes(this.$route.name)) {
        window.close()
      }
      // localStorage.getItem('routeName') localStorage.getItem('routeParams') 判断是不是账号权限的返回
      // localStorage.getItem('isNull') 判断有没有进入 账号权限 编辑 新增 的返回

      if (localStorage.getItem('routeName') !== null) {
        this.$router.push({
          name: localStorage.getItem('routeName'), params: {
            type: localStorage.getItem('routeParams'),
            id: localStorage.getItem('routeParamsId')
          }
        })
        localStorage.removeItem('routeName')
        localStorage.removeItem('routeParams')
        localStorage.removeItem('routeParamsId')
      } else if (localStorage.getItem('returnPath') !== null) {
        this.$store.commit('SET_RETURN_FULLURL', localStorage.getItem('returnPath'))
        this.$router.push({
          path: localStorage.getItem('returnPath')
        })
      } else if (localStorage.getItem('isNull') !== null) {
        this.$router.go(-1)
        localStorage.removeItem('isNull')
      } else {
        if (localStorage.getItem('routeName') === null) {
          if (this.fullUrl !== undefined && this.fullUrl !== '') {
            this.$router.push({ path: this.fullUrl })
          } else if (this.url === undefined || this.url === '') {
            this.$router.go(-1)
          } else {
            this.$router.push({ name: this.url, params: this.params })
          }
        } else if (localStorage.getItem('routeParams') === null) {
          if (localStorage.getItem('isNull') === null) {
            this.$router.push({ name: localStorage.getItem('routeName') })
            localStorage.removeItem('routeName')
          } else {
            this.$router.go(-1)
            localStorage.removeItem('isNull')
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.layout {
  width: 100%;
  height: 100%;
  .return-nav {
    height: 60px;
    width: 100%;
    position: fixed;
    z-index: 2;
    top: 0;
    background: #fff;
    line-height: 60px;
    box-shadow: 0 2px 6px rgba(135,150,176,.18);
  }
  .return-nav-ope {
    display: inline-block;
    padding: 0 20px;
  }
  .return-text {
    vertical-align: bottom;
    font-size: 16px;
  }
  .cont-return {
    box-sizing: border-box;
    height: 100%;
    padding-top: 60px;
    overflow: auto;
  }
  .card-container {
    width: 800px;
    box-shadow: 0 2px 6px rgba(135, 150, 176, 0.26);
    margin: 20px auto 70px;
    padding: 20px;
    background: #fff;
    border-radius: 6px;
    &.large {
      width: 1200px;
      margin-bottom: 50px;
    }
    &.wide {
      width: 1100px;
    }
    &.normal {
      width: 1000px;
    }
    &.normal-clear {
      width: 1000px;
      border: none;
      box-shadow: none;
      border-radius: 0;
      background: none;
      padding: 0;
    }
    &.default {
      width: 800px;
    }
    &.cover {
      box-sizing: border-box;
      width: calc(100% - 40px);
      margin: 20px;
    }
    &.card-footer {
      margin-bottom: 80px;
    }
    &.card-footer2 {
      width: 1000px;
      margin-bottom: 80px;
      padding: 30px;
    }
    &.edit-container {
       box-sizing: border-box;
       box-shadow: none;
       width: calc(100% - 40px);
       margin: 20px;
       padding: 0;
       background: transparent;
     }
     &.check {
       background: transparent;
       width: 1200px;
       box-shadow: none;
     }
  }
}
</style>

